import React from "react";

import styled from "styled-components";

import "./productStatusText.styles.scss";

interface ProductStatusProps {
  mainText: string;
  mainTextColor: string;
  altText?: string;
  altTextColor?: string;
}

const StyledHeading = styled.span``;

export const ProductStatusText = ({
  mainText,
  mainTextColor,
  altText = "",
  altTextColor = "black",
}: ProductStatusProps) => (
  <StyledHeading>
    <h6 className={`main-text ${mainTextColor}`}>
      {mainText} &nbsp;
      <span className={altTextColor}>{altText}</span>
    </h6>
  </StyledHeading>
);
